import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import React, { lazy, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import VideoJS from '../../videoComponent';
import { cameraTypeList } from 'globalconfig/constants/keys';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;

const LiveStreaming = ({
  row,
  videoUrl,
  fetchLiveUrl,
  clearFetchLiveUrlTimeout,
  callback
}) => {
  const i18n = useTranslation();
  const [camera, setCamera] = useState(null);

  const setCameraModalFunction = (e) => {
    clearFetchLiveUrlTimeout();
    setCamera(null);
  };

  useEffect(() => {
    if (videoUrl?.errorMessage) {
      setCamera(null);
    }
  }, [videoUrl]);

  const generateHeader = (unitId, status) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <div style={{ fontWeight: 'unset' }} className="headWrapper">
        {`Unit ID - `}
        <span style={{ fontWeight: '600' }}>{unitId}</span>
      </div>
      {status && (
        <div
          style={{ fontWeight: 'unset', marginRight: '100px' }}
          className="headWrapper"
        >
          {`Status - `}
          <span style={{ fontWeight: '600' }}>{status}</span>
        </div>
      )}
    </div>
  );

  const getContent = () => {
    const isLive = videoUrl?.status?.toLowerCase() === 'live';

    // Check if camera type is Geometris (handle both string and object cases)
    const cameraTypeValue = camera?.cameraType?.value || camera?.cameraType;
    const isGeometris = cameraTypeValue === cameraTypeList['geometris']

    // Case 1: Video not live and no play URL
    if (videoUrl && !isLive && !videoUrl?.playUrl) {
      return {
        header: '',
        content: () => (
          <div className="descModal">
            {generateHeader(camera?.unit_id, videoUrl?.status)}
            <video width="720" height="445" id="video" controls></video>
          </div>
        )
      };
    }

    // Case 2: Video is live with play URL
    if (videoUrl && videoUrl?.playUrl && isLive) {
      // Use iframe for Geometris cameras
      if (isGeometris) {
        const cameraSerialNo = camera?.cameraSerialNo || row?.cameraSerialNo;
        const iframeUrl = `https://skyonicsdevstorage10.z22.web.core.windows.net/cameraViewer.html?serialnumber=${cameraSerialNo}`;

        return {
          content: () => (
            <div className="descModal">
              {generateHeader(camera?.unit_id, videoUrl?.status)}
              <iframe
                src={iframeUrl}
                width="720"
                height="445"
                frameBorder="0"
                allowFullScreen
                title="Geometris Live Camera Viewer"
                style={{
                  width: '100%',
                  maxWidth: '720px',
                  height: '445px',
                  border: 'none'
                }}
              />
            </div>
          )
        };
      }

      // Use VideoJS for other camera types
      const videoJsOptions = {
        autoplay: true,
        controls: true,
        responsive: true,
        fluid: true,
        cameraType: camera.cameraType,
        aspectRatio: '16:8',
        sources: [
          {
            src: videoUrl?.playUrl,
            type: 'application/x-mpegURL'
          }
        ]
      };

      return {
        content: () => (
          <div className="descModal">
            {generateHeader(camera?.unit_id, videoUrl?.status)}
            <VideoJS options={videoJsOptions} />
          </div>
        )
      };
    }

    // Default Case: Fallback content
    return {
      content: () => (
        <div className="descModal">
          {generateHeader(row.unit_id)}
          <video width="720" height="445" id="video" controls></video>
        </div>
      )
    };
  };

  const onCamera = async () => {
    fetchLiveUrl({
      apiId: 'liveStreamingApi',
      cameraSerialNo: row?.cameraSerialNo,
      cameraType: row?.cameraType,
      callback: callback
    });
    setCamera(row);
  };

  return (
    <>
      <div style={{ display: row.cameraSerialNo ? '' : 'none' }}>
        <Icon
          tooltip={i18n.t('common.liveCamera')}
          src={mediaUrls?.camera}
          onClick={onCamera}
        />
      </div>
      {camera && (
        <Modal
          open={true}
          setOpen={setCameraModalFunction}
          data={getContent()}
          width={'760px'}
          withCloseIcon
          alignItemsLeft
          removeTopSpace
        />
      )}
    </>
  );
};

export default LiveStreaming;
